module.exports = __webpack_public_path__ + "img/guifu_logo.bc021645.png";